const autoNgTemplateLoaderTemplate1 = require('./logs.html');

angular.module('portainer.kubernetes').component('kubernetesApplicationLogsView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'KubernetesApplicationLogsController',
  controllerAs: 'ctrl',
  bindings: {
    $transition$: '<',
  },
});
